import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'


export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr()
    }
  }
  static reducer(action, Tournament, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_TOURNAMENTS:
        session.Tournament.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_TOURNAMENTS:
        action?.payload?.forEach(newItem => {
          session.Tournament.upsert(newItem)
        })
        break
      case Types.ADD_TOURNAMENT:
        const id = action?.payload?.id || getId()
        Tournament.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_TOURNAMENT:
        item = Tournament.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_TOURNAMENT:
        Tournament.withId(action.payload.id).delete()
        break
    }
  }
}
